import grapesjs from 'drapcode-builder';
import loadTraits from './traits';

export default grapesjs.plugins.add('webconnect-collection-video-traits', (editor, opts) => {
  const default_traits = {
    link: {
      type: 'webconnect-video',
      label: false,
    },
  };
  let options = {
    ...{
      traits: default_traits,
    },
    ...opts,
  };
  loadTraits(editor, options);
});
